// generated file - do not edit

import Home from './home'

export default { Home }
